export const GET_CATEGORY = 'providers/menuMaker/CategoryDetails/GET_CATEGORY';

export const EDIT_CATEGORY = 'providers/menuMaker/CategoryDetails/EDIT_CATEGORY';

export const GET_PRODUCTS_SORT_CATEGORY = 'providers/menuMaker/CategoryDetails/GET_PRODUCTS_SORT_CATEGORY';

export const UPDATE_PRODUCTS_SORT_CATEGORY = 'providers/menuMaker/CategoryDetails/UPDATE_PRODUCTS_SORT_CATEGORY';
